import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

// Rete di sicurezza globale: un'eccezione in fase di render (es. API non supportata su WebView
// datati) non deve più produrre una "schermata bianca". Mostra un messaggio recuperabile e
// consente di ricaricare l'app. Registra l'errore in console per la diagnosi.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Orbit UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
          <div className="max-w-sm w-full text-center space-y-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="mx-auto h-12 w-12 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <h1 className="font-heading text-lg font-semibold text-slate-800">Si è verificato un problema</h1>
            <p className="text-sm text-slate-500">
              Qualcosa non ha funzionato nel caricamento di questa schermata. Riprova ricaricando l'app.
            </p>
            <Button
              data-testid="app-error-reload"
              className="w-full rounded-lg h-11 font-semibold"
              onClick={() => window.location.reload()}
            >
              Ricarica
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
